import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  SimpleChanges,
  signal
} from "@angular/core";
import { Entity } from "../../../core/models";
import { EntityService } from "../../../core/services/entity.service";
import { MultiselectAutocompleteComponent } from "../multiselect-autocomplete/multiselect-autocomplete.component";

@Component({
  standalone: false,
  selector: "app-multiselect-with-entity-autocomplete",
  templateUrl: "./multiselect-with-entity-autocomplete.component.html"
})
export class MultiselectWithEntityAutocompleteComponent implements OnInit {
  @ViewChild(MultiselectAutocompleteComponent)
  childMultiselectAutocomplete: MultiselectAutocompleteComponent;
  @Output() entitySelected = new EventEmitter<any>();
  @Output() entitiesListed = new EventEmitter<boolean>();
  @Input() placeholder = "Entidad destino";
  @Input() filterDisabled = false;
  @Input() entityType;
  @Input() returnFullValue;
  entityList = signal<Entity[]>([]);
  @Input() maxElementsToSelect = 2;

  @Input() entityListInput: Entity[] | null = null;
  @Input() valueToSelect = "entityCode";
  @Input() valueToSearch = "entityName";
  @Input() clearTrigger = false;
  @Input() disableCondition?: (item: any) => boolean;
  @Input() panelWidth?: string | number;
  constructor(private entityService: EntityService
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['entityListInput'] && this.entityListInput) {
      this.entityList.set([...this.entityListInput]);
      return;
    }

    if (changes && (!changes['filterDisabled'] || !changes['filterDisabled'].currentValue)) {
      this.getEntities();
    }
  }

  async getEntities() {
    if (this.entityListInput && this.entityListInput.length > 0) {
      return;
    }

    this.entityList.set([]);
    if (this.entityType && this.entityType.length > 0) {
      for (let type of this.entityType) {
        const response = await this.entityService.listEntity(type, true).toPromise();
        if (response && response.data && response.data.listEntities) {
          this.entityList.set([...this.entityList(), ...response.data.listEntities]);
        }
      }
    }
  }


  emitEntitiesListed(event: boolean) {
    if (event) {
      this.entitiesListed.emit(true);
    }
  }

  emitDestinationEntities(event) {
    this.entitySelected.emit(event);
  }

  setEntityList(entityList: any[], emitEntitySelectedEvent: boolean = true) {
    this.childMultiselectAutocomplete.setValues(entityList , emitEntitySelectedEvent);
  }

  resetEntitiesSelected() {
    this.childMultiselectAutocomplete.resetForm();
  }

  disableMultiSelect() {
    this.childMultiselectAutocomplete.disableMultiSelect();
  }

}
